import styled from "styled-components";
import { LIGHT_BLUE, NEAR_WHITE } from "../../../config";

export const Container = styled.div`
  width: 100%;
  max-height: 40px;
  padding: 4px 0px;
  display: flex;
  align-items: center;
`;

export const FilterContainer = styled.div<{ isOpen: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  svg.fa-sliders {
    color: ${NEAR_WHITE};
    cursor: pointer;
    font-size: 20px;
    margin-right: 36px;

    pointer-events: ${(props) => (props.isOpen ? "none" : "unset")};

    &.filter-icon--open {
      color: ${LIGHT_BLUE};
    }
  }
`;
